import {
  GET_REVIEW_LIST,
  GET_REVIEW_LIST_SUCCESS,
  GET_REVIEW_LIST_FAILURE,
  GET_REVIEW_DATA,
  GET_REVIEW_DATA_SUCCESS,
  GET_REVIEW_DATA_FAILURE,
  CREATE_REVIEW,
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  UPDATE_REVIEW,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAILURE,
  DELETE_REVIEW,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAILURE,
  ASSIGN_REVIEW_CUSTOMER,
  ASSIGN_REVIEW_CUSTOMER_SUCCESS,
  ASSIGN_REVIEW_CUSTOMER_FAILURE,
  SET_REVIEW_STATUS,
  SET_REVIEW_STATUS_SUCCESS,
  SET_REVIEW_STATUS_FAILURE,
  REPLY_REVIEW,
  REPLY_REVIEW_SUCCESS,
  REPLY_REVIEW_FAILURE,
  GET_REVIEW_PROVIDERS,
  GET_REVIEW_PROVIDERS_SUCCESS,
  GET_REVIEW_PROVIDERS_FAILURE,
  UPDATE_REVIEW_PROVIDER,
  UPDATE_REVIEW_PROVIDER_SUCCESS,
  UPDATE_REVIEW_PROVIDER_FAILURE,
  SYNC_REVIEW_GOOGLE,
  SYNC_REVIEW_GOOGLE_SUCCESS,
  SYNC_REVIEW_GOOGLE_FAILURE,
  GET_REVIEW_STATUS_LIST,
  GET_REVIEW_STATUS_LIST_SUCCESS,
  GET_REVIEW_STATUS_LIST_FAILURE,
  GET_REVIEW_STATUS_DATA,
  GET_REVIEW_STATUS_DATA_SUCCESS,
  GET_REVIEW_STATUS_DATA_FAILURE,
  CREATE_REVIEW_STATUS,
  CREATE_REVIEW_STATUS_SUCCESS,
  CREATE_REVIEW_STATUS_FAILURE,
  UPDATE_REVIEW_STATUS,
  UPDATE_REVIEW_STATUS_SUCCESS,
  UPDATE_REVIEW_STATUS_FAILURE,
  DELETE_REVIEW_STATUS,
  DELETE_REVIEW_STATUS_SUCCESS,
  DELETE_REVIEW_STATUS_FAILURE,
} from "./actionType";

const initialData = {
  // Reviews
  reviewList: [],
  reviewListLoading: false,
  reviewListError: [],

  reviewData: [],
  reviewDataLoading: false,
  reviewDataError: [],

  reviewCreate: [],
  reviewUpdate: [],
  reviewDelete: [],
  reviewAssignCustomer: [],
  reviewSetStatus: [],
  reviewReply: [],
  reviewWriteError: [],

  // Providers
  reviewProviders: [],
  reviewProvidersLoading: false,
  reviewProvidersError: [],
  reviewProviderUpdate: [],
  reviewSyncGoogle: [],
  reviewSyncGoogleLoading: false,
  reviewProviderUpdateLoading: false,
  reviewStatusWriteLoading: false,

  // Status lanes
  reviewStatusList: [],
  reviewStatusListLoading: false,
  reviewStatusListError: [],
  reviewStatusData: [],
  reviewStatusCreate: [],
  reviewStatusUpdate: [],
  reviewStatusDelete: [],
};

const Reviews = (state = initialData, action) => {
  switch (action.type) {
    // ---- Reviews list ----
    case GET_REVIEW_LIST:
      return { ...state, reviewListLoading: true };
    case GET_REVIEW_LIST_SUCCESS:
      return { ...state, reviewList: action.payload, reviewListLoading: false };
    case GET_REVIEW_LIST_FAILURE:
      return {
        ...state,
        reviewListError: action.payload,
        reviewListLoading: false,
      };

    // ---- Review read one ----
    case GET_REVIEW_DATA:
      return { ...state, reviewDataLoading: true };
    case GET_REVIEW_DATA_SUCCESS:
      return { ...state, reviewData: action.payload, reviewDataLoading: false };
    case GET_REVIEW_DATA_FAILURE:
      return {
        ...state,
        reviewDataError: action.payload,
        reviewDataLoading: false,
      };

    // ---- Review create ----
    case CREATE_REVIEW:
      return { ...state };
    case CREATE_REVIEW_SUCCESS:
      return { ...state, reviewCreate: action.payload };
    case CREATE_REVIEW_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Review update ----
    case UPDATE_REVIEW:
      return { ...state };
    case UPDATE_REVIEW_SUCCESS:
      return { ...state, reviewUpdate: action.payload };
    case UPDATE_REVIEW_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Review delete ----
    case DELETE_REVIEW:
      return { ...state };
    case DELETE_REVIEW_SUCCESS:
      return { ...state, reviewDelete: action.payload };
    case DELETE_REVIEW_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Assign to customer ----
    case ASSIGN_REVIEW_CUSTOMER:
      return { ...state };
    case ASSIGN_REVIEW_CUSTOMER_SUCCESS:
      return { ...state, reviewAssignCustomer: action.payload };
    case ASSIGN_REVIEW_CUSTOMER_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Set status / assignee ----
    case SET_REVIEW_STATUS:
      return { ...state };
    case SET_REVIEW_STATUS_SUCCESS:
      return { ...state, reviewSetStatus: action.payload };
    case SET_REVIEW_STATUS_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Reply ----
    case REPLY_REVIEW:
      return { ...state };
    case REPLY_REVIEW_SUCCESS:
      return { ...state, reviewReply: action.payload };
    case REPLY_REVIEW_FAILURE:
      return { ...state, reviewWriteError: action.payload };

    // ---- Providers ----
    case GET_REVIEW_PROVIDERS:
      return { ...state, reviewProvidersLoading: true };
    case GET_REVIEW_PROVIDERS_SUCCESS:
      return {
        ...state,
        reviewProviders: action.payload,
        reviewProvidersLoading: false,
      };
    case GET_REVIEW_PROVIDERS_FAILURE:
      return {
        ...state,
        reviewProvidersError: action.payload,
        reviewProvidersLoading: false,
      };

    case UPDATE_REVIEW_PROVIDER:
      return { ...state, reviewProviderUpdateLoading: true };
    case UPDATE_REVIEW_PROVIDER_SUCCESS:
      return {
        ...state,
        reviewProviderUpdate: action.payload,
        reviewProviderUpdateLoading: false,
      };
    case UPDATE_REVIEW_PROVIDER_FAILURE:
      return {
        ...state,
        reviewWriteError: action.payload,
        reviewProviderUpdateLoading: false,
      };

    case SYNC_REVIEW_GOOGLE:
      return { ...state, reviewSyncGoogleLoading: true };
    case SYNC_REVIEW_GOOGLE_SUCCESS:
      return {
        ...state,
        reviewSyncGoogle: action.payload,
        reviewSyncGoogleLoading: false,
      };
    case SYNC_REVIEW_GOOGLE_FAILURE:
      return {
        ...state,
        reviewWriteError: action.payload,
        reviewSyncGoogleLoading: false,
      };

    // ---- Status lanes ----
    case GET_REVIEW_STATUS_LIST:
      return { ...state, reviewStatusListLoading: true };
    case GET_REVIEW_STATUS_LIST_SUCCESS:
      return {
        ...state,
        reviewStatusList: action.payload,
        reviewStatusListLoading: false,
      };
    case GET_REVIEW_STATUS_LIST_FAILURE:
      return {
        ...state,
        reviewStatusListError: action.payload,
        reviewStatusListLoading: false,
      };

    case GET_REVIEW_STATUS_DATA:
      return { ...state };
    case GET_REVIEW_STATUS_DATA_SUCCESS:
      return { ...state, reviewStatusData: action.payload };
    case GET_REVIEW_STATUS_DATA_FAILURE:
      return { ...state, reviewStatusListError: action.payload };

    case CREATE_REVIEW_STATUS:
      return { ...state, reviewStatusWriteLoading: true };
    case CREATE_REVIEW_STATUS_SUCCESS:
      return {
        ...state,
        reviewStatusCreate: action.payload,
        reviewStatusWriteLoading: false,
      };
    case CREATE_REVIEW_STATUS_FAILURE:
      return {
        ...state,
        reviewStatusListError: action.payload,
        reviewStatusWriteLoading: false,
      };

    case UPDATE_REVIEW_STATUS:
      return { ...state, reviewStatusWriteLoading: true };
    case UPDATE_REVIEW_STATUS_SUCCESS:
      return {
        ...state,
        reviewStatusUpdate: action.payload,
        reviewStatusWriteLoading: false,
      };
    case UPDATE_REVIEW_STATUS_FAILURE:
      return {
        ...state,
        reviewStatusListError: action.payload,
        reviewStatusWriteLoading: false,
      };

    case DELETE_REVIEW_STATUS:
      return { ...state };
    case DELETE_REVIEW_STATUS_SUCCESS:
      return { ...state, reviewStatusDelete: action.payload };
    case DELETE_REVIEW_STATUS_FAILURE:
      return { ...state, reviewStatusListError: action.payload };

    default:
      return state;
  }
};

export default Reviews;
